$(function(){
    $('#shopify-section-template--19384520769715__176016651422c48f40').addClass('active');
    const $faqTitles = $('.iwish-faq-container .faq-title-container');

    function setFaqState($title, isOpen) {
        const $content = $title.next('.faq-content');
        const $row = $title.closest('.iwish-faq-row');
        if (!$content.length) return;

        if (isOpen) {
            $title.addClass('active').attr('aria-expanded', 'true');
            $row.addClass('expanded');
            $content.css('max-height', `${$content.prop('scrollHeight')}px`);
        } else {
            $title.removeClass('active').attr('aria-expanded', 'false');
            $row.removeClass('expanded');
            $content.css('max-height', '0px');
        }
    }

    $faqTitles.each(function() {
        const $title = $(this);
        const $content = $title.next('.faq-content');
        if (!$content.length) return;

        $title.attr('aria-expanded', $title.hasClass('active') ? 'true' : 'false');
        $content.css('max-height', '0px');

        if ($title.hasClass('active')) {
            setFaqState($title, true);
        } else {
            setFaqState($title, false);
        }
    });

    $faqTitles.on('click', function(){
        const $title = $(this);
        const isOpen = $title.hasClass('active');
        setFaqState($title, !isOpen);
    });

    $(window).on('resize', function() {
        $('.iwish-faq-container .faq-title-container.active').each(function() {
            const $title = $(this);
            const $content = $title.next('.faq-content');
            if ($content.length) {
                $content.css('max-height', `${$content.prop('scrollHeight')}px`);
            }
        });
    });

    $('.iwish-tab-container .tab-head').on('click',function(){
        let id = $(this).attr('data');
        $('.iwish-tab-container .tab-head').removeClass('active');
        $(this).addClass('active');
        let s_id = [
            'shopify-section-template--19384520769715__176016651422c48f40',
            'shopify-section-template--19384520769715__176016652825356a9b',
            'shopify-section-template--19384520769715__17602466288dff597e',
            'shopify-section-template--19384520769715__1760248289deb9efd7'
        ];

        $.each(s_id,function(i,v){
            // console.log(id);
            if(id == v){
                $('#'+v).addClass('active');
            }else{
                $('#'+v).removeClass('active');
            }
            
        });
    });
});